import { useState, useEffect, useRef, useCallback } from "react";
import useThrottledOnScroll from "./useThrottledOnScroll";

export interface IScrollSpyAccordionItemProps {
  hash: string;
  node: HTMLFormElement;
}

interface IScrollSpyProps {
  items: string[];
}

const useScrollSpy = ({ items = [] }: IScrollSpyProps) => {
  const itemsWithNodeRef = useRef([]);
  useEffect(() => {
    itemsWithNodeRef.current = getItemsClient(items);
  }, [items]);

  const [activeState, setActiveState] = useState("premiseBlock");

  const findActiveIndex = useCallback(() => {
    let active;
    for (let i = itemsWithNodeRef.current.length - 1; i >= 0; i--) {
      const item: IScrollSpyAccordionItemProps = itemsWithNodeRef.current[i];
      if (
        item.node &&
        item.node.offsetTop <
          document.documentElement.scrollTop +
            document.documentElement.clientHeight / 3
      ) {
        active = item;
        break;
      }
    }
    if (active && activeState !== active.hash) {
      setActiveState(active.hash);
    }
  }, [activeState]);

  useThrottledOnScroll(items.length > 0 ? findActiveIndex : null, 800);

  return activeState;
};

const getItemsClient = (items: any) =>
  items.map((item: any) => {
    const itemId = item.replace(/[A-Z]/g, (m: string) => `-${m.toLowerCase()}`);
    return { hash: item, node: document.getElementById(`${itemId}`) };
  });

export default useScrollSpy;
